import BaseService from './Base.Service';

class UserService extends BaseService {
    constructor() {
        super('users');
    }

    async updateBankData(userId, bankData) {
        try {
            const { data } = await this.conn.axios.put(`/user-bank-data/${userId}`, bankData);
            return this.sendSuccess(data, 'Registro atualizado com sucesso!');
        } catch (err) {
            const errorMsg = err?.response?.data?.msg || 'Erros foram encontrados ao recuperar dados';
            return this.sendError(errorMsg, false, err);
        }
    }

    /**
     * Exportar todos os colaboradores (sem paginação) para planilha
     * @param {string} queryString
     * @returns {Promise}
     */
    async exportAll(queryString = '') {
        try {
            const response = await this.conn.axios.get(`/${this.path}/export?${queryString}`);
            return response.data;
        } catch (err) {
            return this.sendError('Erro ao exportar colaboradores', 400, err);
        }
    }

    async getBankNames() {
        try {
            const { data } = await this.conn.axios
                .get(`https://brasilapi.com.br/api/banks/v1`);
            return data;
        } catch (err) {
            console.log(err);
            return false;
        }
    }
}

export default UserService;
